function OwnerPic({pic,hasBanner}){
  return(
    <>
      <img src={pic} width="60px" className="img-fluid rounded-circle" style={hasBanner() ? {border:'4px solid var(--color-background-1)'} : null} alt="owner-pic" />
    </>
  );
}

export default OwnerPic;
